import { useParams } from 'react-router-dom';
import FileManager from '../components/FileManager';

function InfoYear() {
  const params = useParams();
  const year = parseInt(params.year || "");
  const folderId = "info-" + year;
  const folderName = year + ". ročník";

  if (year > 9 || year < 3) {
    throw new Error("Wrong year!");
  }

  return <>
    <FileManager folderId={folderId} folderName={folderName} />
  </>
}

export default InfoYear;